export const environment = {
    production: true,
    pbatID: 'PBAT340782',
    auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IkFkbWluIiwiaWF0IjoxNjIwMTMxNTYxfQ.7iTT5-7gnQVrabIb4af5wMRWWfPbWQfIZXBWvL8wA-A",
    title: 'MOYEE TRIPLE',
    wetmillLatitude: "-1.1663197956282754",
    wetmillLongitude: "36.82414828971005",
    roasterLatitude: "-1.4729248260071695",
    roasterLongitude: "36.97317071518601"
  };